module.exports = __webpack_public_path__ + "static/media/2.a6fb3fd2.png";